import React from "react";
import { connect } from "react-redux";
import AlignLeft from "./AlignLeft";
import AlignCenter from "./AlignCenter";
import AlignRight from "./AlignRight";

class AlignItems extends React.Component {
  render() {
    const layers = this.props.layers;
    let multipleElements = false;

    layers.forEach((layer) => {
      if (layer.text_elements.length + layer.image_elements.length > 1) {
        multipleElements = true;
      }
    });

    return (
      <div className="tool tool--alignitems">
        <h4 className="tool__header">Align Items</h4>
        <div className="tool__options">
          <AlignLeft
            handleAlignLeft={this.props.handleAlignLeft}
            enabled={multipleElements}
          />
          <AlignCenter
            handleAlignCenter={this.props.handleAlignCenter}
            enabled={multipleElements}
          />
          <AlignRight
            handleAlignRight={this.props.handleAlignRight}
            enabled={multipleElements}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    layers: state.design.present.layer_set,
  };
}

export default connect(mapStateToProps)(AlignItems);
